import * as types from '../types';

const INITIAL_STATE = {
    notificationList: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.NOTIFICATIONS_UPDATE_STATE:
            return { ...state, ...action.payload };
        case types.NOTIFICATIONS_RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
